import { useCallback, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";
import { MAX_RETRIES } from "../../configs/configs";

function useGetCategory() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [category, setCategory] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const { retryCount, setRetryCount } = useRetry(
    () => getCategory(),
    MAX_RETRIES
  );

  const getCategory = useCallback(() => {
    fetchWrapper({
      endpoint_url: "category/getCategory",
      set_content_type_header: false,
      method: "GET",
      setLoading: setCategoryLoading,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setCategory(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "fetch",
            message: "Get Category",
          });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "response",
            message: "Get Category",
          });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    getCategory();
  }, []);

  return { category, categoryLoading, getCategory };
}

export default useGetCategory;
